import { render, staticRenderFns } from "./DialogoDeMetaDaAcaoDeCashback.vue?vue&type=template&id=22b91186&scoped=true&"
import script from "./DialogoDeMetaDaAcaoDeCashback.vue?vue&type=script&lang=ts&"
export * from "./DialogoDeMetaDaAcaoDeCashback.vue?vue&type=script&lang=ts&"
import style0 from "./DialogoDeMetaDaAcaoDeCashback.vue?vue&type=style&index=0&id=22b91186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b91186",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCard,VCardActions,VCardText,VDialog,VForm,VIcon,VProgressLinear,VSpacer})
